__turbopack_context__.v({
  "content": "CollateralTeaser-module-scss-module__WQ0A-G__content",
  "cover": "CollateralTeaser-module-scss-module__WQ0A-G__cover",
  "cta": "CollateralTeaser-module-scss-module__WQ0A-G__cta",
  "description": "CollateralTeaser-module-scss-module__WQ0A-G__description",
  "eyebrow": "CollateralTeaser-module-scss-module__WQ0A-G__eyebrow",
  "eyebrowText": "CollateralTeaser-module-scss-module__WQ0A-G__eyebrowText",
  "root": "CollateralTeaser-module-scss-module__WQ0A-G__root",
  "title": "CollateralTeaser-module-scss-module__WQ0A-G__title",
  "tray": "CollateralTeaser-module-scss-module__WQ0A-G__tray",
});
